function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { LazyImage } from 'react-lazy-images';
const CDN_PATH = 'https://cdn.heydoctor.com';
export const CdnImage = ({
  path,
  src,
  minWidth = 10,
  minHeight = 10,
  alt,
  style,
  ...props
}) => /*#__PURE__*/React.createElement(LazyImage, {
  src: src || `${CDN_PATH}/${path}`,
  alt: alt,
  placeholder: ({
    ref
  }) => /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      minWidth: (style === null || style === void 0 ? void 0 : style.width) || minWidth,
      minHeight: (style === null || style === void 0 ? void 0 : style.height) || minHeight
    }
  }),
  actual: ({
    imageProps
  }) => /*#__PURE__*/React.createElement("img", _extends({
    alt: alt
  }, imageProps, {
    style: style
  }, props))
});